import { ProductQuoteV2Dimension } from '@orus.eu/dimensions'
import type { MrphQuoteV2 } from '@orus.eu/quote'

export class MrphQuoteV2Dimension<NAME extends string, Quote extends MrphQuoteV2> extends ProductQuoteV2Dimension<
  NAME,
  Quote
> {}
